module.exports = __webpack_public_path__ + "img/government.d11c000f.svg";